module.exports = __webpack_public_path__ + "media/images/parceiros_pagamentos/resized/truora-shield-5d9f100cbd3581466cd0e56009f20a35.svg";